import React from 'react';
import { Outlet } from 'react-router-dom';

export default function MinimalLayout() {
  return (
    <main>
      <Outlet />
    </main>
  );
}
